export default {"src":"/_next/static/media/care_respect_01.0199fdb7.svg","height":80,"width":95,"blurWidth":0,"blurHeight":0};